import {CloneWithPrototypes, GetErrorMessagesUnderElement} from "js-vextensions";
import {Column, RowLR, Text, TextInput} from "react-vcomponents";
import {BaseComponentPlus} from "react-vextensions";
import {Script} from "../../../Server/DB/scripts/@Script";
import {User} from "../../../Server/DB/users/@User";
import {GenericEntryInfoUI} from "../../@Shared/CommonPropUIs/GenericEntryInfoUI";
import {name_general} from "../../../Utils/General/SharedPatterns";
import {TagsInput} from "../../../Utils/ReactComponents/TagsInput";
import {Observer} from "web-vcore";
import {GetUser} from "../../../Server/DB/users";
import {EffectPreviewButton} from "../../@Shared/TagTargetEntryUI";
import React from "react";
import {DetailsUI_Base_Props, useDetailsUICore} from "../../@Shared/DetailsUI_Base.js";
import {observer_mgl} from "mobx-graphlink";

/*export function ShowAddScriptDialog(initialData?: Partial<Script>, postAdd?: (id: string)=>any) {
	let newEntry = new Script(E({
		name: "",
	}, initialData));
	const getCommand = ()=>new AddScript({entry: newEntry});

	const boxController: BoxController = ShowMessageBox({
		title: "Add script", cancelButton: true,
		message: observer_simple(()=>{
			const tempCommand = getCommand();
			boxController.UpdateOptions({okButtonProps: {
				enabled: tempCommand.Validate_Safe() == null,
				title: tempCommand.validateError,
			}});

			return (
				<Column style={DialogStyle(600)}>
					<ScriptDetailsUI baseData={newEntry} forNew={true}
						onChange={(val, error)=>{
							newEntry = val;
							boxController.UpdateUI();
						}}/>
				</Column>
			);
		}),
		onOK: async()=>{
			const {id} = await getCommand().RunOnServer();
			if (postAdd) postAdd(id);
		},
	});
}*/

type Props = DetailsUI_Base_Props<Script>;
//type Props_Enhanced = Props & {newData: Script, Change};

const splitAt = 120, width = "100%";

export const ScriptDetailsUI = observer_mgl((props: DetailsUI_Base_Props<Script>)=>{
	const {phase, style} = props;
	const {rootRef, newData, helpers} = useDetailsUICore(props);
	const {Change, creating, enabled} = helpers;
	//const nodeAccessPolicy = GetAccessPolicy(newData.nodeAccessPolicy);
	const creator = phase != "create" && GetUser(newData.creator);

	//const propsEnhanced = {...props, newData, Change};
	return (
		<Column ref={rootRef} style={style}>
			{phase != "create" &&
				<GenericEntryInfoUI id={newData.id} creatorID={newData.creator} createdAt={newData.createdAt}/>}
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Text>Name: </Text>
				<TextInput pattern={name_general} required
					enabled={enabled} style={{width: "100%"}}
					value={newData.name} onChange={val=>Change(newData.name = val)}/>
			</RowLR>
			{/*<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Text>Type: </Text>
				<Select options={GetEntries(ScriptType)} enabled={enabled} style={{width: "100%"}}
					value={newData.type} onChange={val=>Change(newData.type = val, Script.InitDefaults(newData))}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Row center>
					<Pre>Visibility:</Pre>
					<InfoButton ml={5} text={`
						Visible: Shown publicly in the list of scripts.
						Hidden: Hidden in script list (other than to mods), but still accessible through reading of raw db contents. (so not guarantee of privacy)
					`.AsMultiline(0)}/>
				</Row>
				<Select options={GetEntries(EffectVisibility)} enabled={enabled} value={newData.visibility} onChange={val=>Change(newData.visibility = val)}/>
			</RowLR>*/}
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Text>Suggested tags:</Text>
				<TagsInput enabled={enabled} style={{width: "100%"}} value={newData.tags} onChange={val=>Change(newData.tags = val)}/>
			</RowLR>
			<EffectPreviewButton mt={5} group="scripts" entry={newData} startText="Preview script" stopText="Stop preview" width={200}/>
		</Column>
	);
});